module.exports = __webpack_public_path__ + "assets/img/pyramid_people.6b8386c1.png";